export function resolveImmediateHealingOutcome({
  target,
  amount,
  deathSaveConfig = {},
} = {}) {
  const healAmount = parseInt(amount, 10) || 0;
  if (!target || healAmount <= 0) {
    return {
      kind: 'none',
      healAmount,
      finalHp: target?.currentHp ?? 0,
      actualHeal: 0,
    };
  }

  if (target.currentHp <= 0 && target.deathSaves && !target.deathSaves.dead) {
    if (target.deathSaves.shieldActive && !target.deathSaves.shieldBroken) {
      return {
        kind: 'heal-check',
        healAmount,
        finalHp: target.currentHp,
        actualHeal: 0,
      };
    }

    const reviveHp = deathSaveConfig.reviveHpMode === 'fixed'
      ? deathSaveConfig.fixedReviveHp
      : healAmount;
    const finalHp = Math.min(Math.max(1, reviveHp), target.maxHp);
    return {
      kind: 'revive',
      healAmount,
      finalHp,
      actualHeal: Math.max(0, finalHp - (target.currentHp || 0)),
      conditions: (target.conditions || []).filter((condition) => condition !== 'Unconscious' && condition !== 'Prone' && condition !== 'Dead'),
    };
  }

  const finalHp = Math.min(target.maxHp, target.currentHp + healAmount);
  return {
    kind: 'heal',
    healAmount,
    finalHp,
    actualHeal: Math.max(0, finalHp - (target.currentHp || 0)),
  };
}

export function resolveImmediateTempHpOutcome({
  target,
  amount,
} = {}) {
  const requestedAmount = parseInt(amount, 10) || 0;
  const currentTempHp = target?.tempHp || 0;
  if (!target || requestedAmount <= 0) {
    return {
      kind: 'none',
      requestedAmount,
      currentTempHp,
      finalTempHp: currentTempHp,
      appliedDelta: 0,
      changed: false,
    };
  }

  const finalTempHp = Math.max(currentTempHp, requestedAmount);
  return {
    kind: 'temp-hp',
    requestedAmount,
    currentTempHp,
    finalTempHp,
    appliedDelta: Math.max(0, finalTempHp - currentTempHp),
    changed: finalTempHp !== currentTempHp,
  };
}
